<template>
<div class="container">
  <div class="items-row">

    <div class="left">
      <picture>
        <source media="(max-width: 1199px)" srcset="@/assets/images/signup/mike.png">
        <img src="@/assets/images/signup/mike@2x.png" class="avatar" alt="Mike Avatar">
      </picture>

      <div class="side">
        <img src="@/assets/images/report/stars.svg" class="stars" alt="stars">
        <span class="headline">“ClickCease saves us 15-20% of our Google Ads spend every month”</span>
        <span class="description">Mike Moll, founder, Market Me Consulting</span>
      </div>
    </div>

    <div class="middle">
      <picture>
        <source media="(max-width: 1199px)" srcset="@/assets/images/signup/trust_icons.png">
        <img src="@/assets/images/signup/trust_icons@2x.png" alt="trust icons">
      </picture>
    </div>

    <div class="right">
      <img src="@/assets/images/signup/lock_with_stars.svg" class="lock" alt="security">
      <div class="side">
        <span class="headline">CCPA + GDPR</span>
        <span class="description">ClickCease is Committed To Protecting Your Data And Respecting Your Privacy</span>
      </div>
    </div>

  </div>
</div>
</template>

<script>
export default {
  name: "Decoration"
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/colors";
@import "src/assets/style/responsive";

.items-row {
  display: grid;
  grid-template-columns: repeat(3 ,1fr);
  column-gap: 40px;
  align-items: center;
  justify-content: space-between;

  @include mobile {
    grid-template-columns: 1fr;
  }
}
.left , .right, .middle {
  display: flex;
  max-height: 120px;
  img {
    max-height: 120px;
  }
}
.left {
  display: flex;

  img.avatar {
    max-height: 68px;
    margin-right: 16px;
  }
  .side {
    * {
      display: block;
      text-align: left;
      margin-bottom: 12px;

      &:last-child {
        margin: unset;
      }
    }
  }
}
.middle {
  border-right: 1px solid $darkGrayBorder;
  border-left: 1px solid $darkGrayBorder;

  @include mobile {
    border: unset;
  }
  picture {
    margin: auto;
  }
  img {
    text-align: center;
  }
}
.right {
  img.lock {
    height: 40px;
    margin-right: 16px;
  }
  .headline {
    font-size: 18px;
    margin-bottom: 8px;
  }
  .description {
    font-size: 16px;
  }
}
.headline {
  display: block;
  font-weight: bold;
  font-size: 16px;
  color: $black;
}
.description {
  font-family: "Sofia Pro Light";
  font-size: 14px;
  color: $descriptionGray;
}
</style>